import { useUserSession } from '../../models/hooks/appStateHooks';
import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';

export function useGiftingAddBalanceMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: any) => void;
}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ amount }: { amount: number }) => {
			return userSession.webServiceHelper.callAsync<any>(`gifting/addbalance?amount=${amount}`, 'POST');
		},
		onError,
		onSuccess,
	});
}
